import { render, staticRenderFns } from "./PreviewMessage.vue?vue&type=template&id=601332c7&scoped=true&"
import script from "./PreviewMessage.vue?vue&type=script&lang=js&"
export * from "./PreviewMessage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMessage.vue?vue&type=style&index=0&id=601332c7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601332c7",
  null
  
)

export default component.exports